import { BottomButton, BottomFooter, FormContainer } from './styles';
import { useTranslate } from '@tolgee/react';
import CheckboxGroup from './CheckboxGroup';
import { RegionCheckbox } from './RegionCheckbox';
import { RightOutlined } from '@ant-design/icons';
import { Formik } from 'formik';
import FormField from 'components/FormField';
import { MercadoAuthFormValues } from '../hooks/useMercadoAuthShop';

interface MercadoShopTypeProps {
  onNext?: (values: MercadoAuthFormValues) => void;
}

export const MercadoShopType = (props: MercadoShopTypeProps) => {
  const { onNext } = props;
  const { t } = useTranslate();

  return (
    <Formik<MercadoAuthFormValues>
      initialValues={{}}
      onSubmit={(values) => {
        onNext?.(values);
      }}
    >
      {({ values, setFieldValue, submitForm }) => {
        const btnDisable = !values.shopType || (values.shopType === 'LOCAL' && !values.region);
        return (
          <FormContainer layout="vertical">
            <FormField label={t('authShop.请选择您要添加的店铺类型')} name="shopType" required>
              {({ field }) => (
                <CheckboxGroup
                  options={[
                    {
                      value: 'CROSS',
                      render: <>{t('ViewShops.CROSS')}</>,
                    },
                    {
                      value: 'LOCAL',
                      render: <>{t('ViewShops.LOCAL')}</>,
                    },
                  ]}
                  value={field.value}
                  onChange={(shopType) => {
                    setFieldValue('region', undefined);
                    field.onChange(shopType);
                  }}
                />
              )}
            </FormField>
            {values.shopType &&
              (values.shopType === 'LOCAL' ? (
                <FormField label={t('authShop.请选择店铺站点')} name="region" required>
                  {({ field }) => (
                    <RegionCheckbox
                      options={['BR', 'MX', 'AR', 'CO', 'CL']}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                </FormField>
              ) : (
                <p className="text-content-200">
                  {t('目前仅支持巴西、墨西哥、阿根廷站点，其余站点将陆续接入')}
                </p>
              ))}
            <BottomFooter>
              <BottomButton disabled={btnDisable} size="large" type="primary" onClick={submitForm}>
                {t('authShop.下一步')}
                <RightOutlined />
              </BottomButton>
            </BottomFooter>
          </FormContainer>
        );
      }}
    </Formik>
  );
};
